/**
 * Lifecycle status of an organization.
 *
 * - ACTIVE: subscription in good standing, members can use resources.
 * - SUSPENDED: temporarily blocked (e.g., payment failure); read-only.
 * - CANCELED: subscription canceled, members deactivated.
 *
 * Mirrors the backend OrganizationStatusEnum.
 */
export enum OrganizationStatusEnum {
  ACTIVE = "ACTIVE",
  SUSPENDED = "SUSPENDED",
  CANCELED = "CANCELED",
}
